import React from 'react';
import PropTypes from 'prop-types';

import InputInlineEditable from 'core/gd-components/input-inline-editable/input-inline-editable';

export default class InputDuration extends React.Component {
    static propTypes = {
        value: PropTypes.number,

        placeholder: PropTypes.string,
        type: PropTypes.oneOf(['default', 'form-input', 'inline', 'list']),
        disabled: PropTypes.bool,

        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onChange: PropTypes.func
    };

    static defaultProps = {
        type: 'default',
        disabled: false
    };

    state = {
        isFocused: false,
        value: this.props.value,
        invalidValue: false
    }

    constructor(props, context) {
        super(props, context);

        this.lastCommitValue = props.value;
        this.commited = true;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.commited && prevState.value !== this.props.value)
            this.updateValue(this.props.value);
    }

    setActive = (e) => {
        e.stopPropagation();

        this.setState({isFocused: true}, ()=>{
            if (this.refs.input) this.refs.input.focus();
        });
    }

    setInactive = () => {this.setState({isFocused: false})}

    updateValue = (val, callback) => {
        this.setState({
            value: val,
            invalidValue: !(!isNaN(val) || val.length === 0)
        }, ()=>{if (callback) callback()});
    }

    onFocus = (e) => {if (this.props.onFocus) this.props.onFocus(e)}

    onBlur = (e) => {
        this.updateValue(this.lastCommitValue, ()=>{
            if (this.props.onBlur) this.props.onBlur(e);
            this.setInactive();
        });
    }

    onValueChange = (newValue) => {
        this.commited = true;

        if (!isNaN(newValue) || newValue.length === 0) {
            if (this.props.onChange) this.props.onChange(parseFloat(newValue));
            this.lastCommitValue = newValue;
        }
    }

    onImmediateChange = (newValue) => {
        this.commited = false;
        this.updateValue(newValue);
    }

    _isEmpty = () => _.isNil(this.state.value)

    getStringValue = () => {
        let res = this.state.value;
        if (!this._isEmpty() && !this.state.invalidValue) {
            res = typeof this.state.value === 'number' ?
                this.state.value.toFixed(this.props.decimalPlaces)
                :
                parseFloat(this.state.value).toFixed(this.props.decimalPlaces);
        }

        return isNaN(res) ? null : res;
    }

    renderActive = () => {
        const isEmpty = this._isEmpty();

        const classes = Classes('gd-duration-input', 'active', this.props.type + '-type', this.props.className, {
            "is-disabled": this.props.disabled,
        });

        const inputClasses = Classes("duration-value", {
            "invalid-value": this.state.invalidValue,
            "is-empty": isEmpty || this.state.value === 0
        });

        return (
            <div className={classes} style={this.props.style}>
                <InputInlineEditable ref="input"
                                     className={inputClasses}
                                     placeholder=""
                                     disabled={this.props.disabled}
                                     value={!isEmpty ? this.getStringValue() : null}
                                     onFocus={this.onFocus}
                                     onBlur={this.onBlur}
                                     onChange={this.onValueChange}
                                     onImmediateChange={this.onImmediateChange}
                                     autoSaveChanges={false}
                                     autoSaveOnBlur={true}/>
            </div>
        );
    }

    renderInactive = () => {
        const isEmpty = this._isEmpty();

        const classes = Classes('gd-duration-input', 'inactive', this.props.type + '-type', this.props.className, {
            "is-disabled": this.props.disabled,
        });

        const inputClasses = Classes("duration-value", {
            "invalid-value": this.state.invalidValue
        });

        const durationValueClasses = Classes("duration-value-label ui5-txt-less-important-small txt-truncate", {
            "is-empty": isEmpty || this.state.value === 0
        });

        const placeholder = isEmpty && this.props.type === 'list' ? this.props.placeholder : null;

        return (
            <div className={classes} style={this.props.style} onClick={!this.props.disabled ? this.setActive : null}>
                <div className={inputClasses}>
                    <div className={durationValueClasses}>
                        {!isEmpty && <span>{this.getStringValue()}</span>}
                        {false && !isEmpty && <span className="symbol">d.</span>}
                        {placeholder}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return this.state.isFocused || ["form-input"].includes(this.props.type) ? this.renderActive() : this.renderInactive();
    }
}
